/**
 * @generated SignedSource<<4e1761d8a470b40e5adc46ff912f66ff>>
 * @relayHash 5e2ee4b1409bd94c493ff2aa404a8417
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1474f2f8bebba9d5221546b3bc69c4a186d0b8ab0687a3ae78f336d6f34f275e

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GlobalSideNavigationAGGRelayConnectionQuery$variables = {
  cloudId: string;
  entityAriUserSideNavSettings: string;
  fetchGlobalShortcutsAvailableProducts: boolean;
  fetchOldEntityRecord: boolean;
  navPlatMenuDataEntityAri: string;
  navPlatSidebarDataEntityAri: string;
  ownerAri: string;
};
export type GlobalSideNavigationAGGRelayConnectionQuery$data = {
  readonly navPlatL1MenuData: {
    readonly " $fragmentSpreads": FragmentRefs<"useNavSettingsService">;
  } | null | undefined;
  readonly navPlatSidebarData: {
    readonly " $fragmentSpreads": FragmentRefs<"useNavSettingsService">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"useGlobalShortcutsDataRelay" | "useNetworkSideNavUserData">;
};
export type GlobalSideNavigationAGGRelayConnectionQuery = {
  response: GlobalSideNavigationAGGRelayConnectionQuery$data;
  variables: GlobalSideNavigationAGGRelayConnectionQuery$variables;
};
({
  "__relay_internal__pv__getpagesizevaluerelayproviderts": pageSizeValue_provider
} as {
  readonly __relay_internal__pv__getpagesizevaluerelayproviderts: {
    readonly get: () => number;
  };
});

import pageSizeValue_provider from '../../controllers/user-state/persistence/use-nav-settings-service/get-page-size-value.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityAriUserSideNavSettings"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchGlobalShortcutsAvailableProducts"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchOldEntityRecord"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "navPlatMenuDataEntityAri"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "navPlatSidebarDataEntityAri"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ownerAri"
},
v7 = {
  "kind": "Variable",
  "name": "ownerAri",
  "variableName": "ownerAri"
},
v8 = [
  {
    "kind": "Variable",
    "name": "entityAri",
    "variableName": "navPlatMenuDataEntityAri"
  },
  (v7/*: any*/)
],
v9 = [
  {
    "kind": "FragmentSpread",
    "name": "useNavSettingsService"
  }
],
v10 = [
  {
    "kind": "Variable",
    "name": "entityAri",
    "variableName": "navPlatSidebarDataEntityAri"
  },
  (v7/*: any*/)
],
v11 = [
  {
    "concreteType": "SettingsMenuItem",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "menuId"
      },
      {
        "kind": "ScalarField",
        "name": "visible"
      }
    ]
  }
],
v12 = [
  {
    "concreteType": "SettingsDisplayProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "key"
      },
      {
        "kind": "ScalarField",
        "name": "value"
      }
    ]
  }
],
v13 = {
  "kind": "ScalarField",
  "name": "id"
},
v14 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v15 = {
  "kind": "ScalarField",
  "name": "productType"
},
v16 = {
  "kind": "ScalarField",
  "name": "url"
},
v17 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "__relay_internal__pv__getpagesizevaluerelayproviderts"
  }
],
v18 = [
  {
    "args": (v17/*: any*/),
    "concreteType": "SettingsMenuItemConnection",
    "kind": "LinkedField",
    "name": "sidebar",
    "plural": false,
    "selections": (v11/*: any*/)
  },
  {
    "args": (v17/*: any*/),
    "concreteType": "SettingsDisplayPropertyConnection",
    "kind": "LinkedField",
    "name": "properties",
    "plural": false,
    "selections": (v12/*: any*/)
  },
  (v13/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GlobalSideNavigationAGGRelayConnectionQuery",
    "selections": [
      {
        "condition": "fetchOldEntityRecord",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "useNetworkSideNavUserData"
          }
        ]
      },
      {
        "condition": "fetchGlobalShortcutsAvailableProducts",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "useGlobalShortcutsDataRelay"
          }
        ]
      },
      {
        "alias": "navPlatL1MenuData",
        "args": (v8/*: any*/),
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_navigationCustomisation",
        "plural": false,
        "selections": (v9/*: any*/)
      },
      {
        "alias": "navPlatSidebarData",
        "args": (v10/*: any*/),
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_navigationCustomisation",
        "plural": false,
        "selections": (v9/*: any*/)
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__getpagesizevaluerelayproviderts"
      }
    ],
    "kind": "Operation",
    "name": "GlobalSideNavigationAGGRelayConnectionQuery",
    "selections": [
      {
        "condition": "fetchOldEntityRecord",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "userSideNavSettings",
            "args": [
              {
                "kind": "Variable",
                "name": "entityAri",
                "variableName": "entityAriUserSideNavSettings"
              },
              (v7/*: any*/)
            ],
            "concreteType": "SettingsNavigationCustomisation",
            "kind": "LinkedField",
            "name": "settings_navigationCustomisation",
            "plural": false,
            "selections": [
              {
                "concreteType": "SettingsMenuItemConnection",
                "kind": "LinkedField",
                "name": "sidebar",
                "plural": false,
                "selections": (v11/*: any*/)
              },
              {
                "concreteType": "SettingsDisplayPropertyConnection",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": (v12/*: any*/)
              },
              (v13/*: any*/)
            ]
          }
        ]
      },
      {
        "condition": "fetchGlobalShortcutsAvailableProducts",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              }
            ],
            "kind": "LinkedField",
            "name": "appSwitcher_availableProductsBySite",
            "plural": false,
            "selections": [
              (v14/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "products",
                    "plural": true,
                    "selections": [
                      (v14/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v15/*: any*/),
                          (v16/*: any*/)
                        ],
                        "type": "AppSwitcherSingleUrlProduct"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v15/*: any*/),
                          {
                            "concreteType": "AppSwitcherProductSite",
                            "kind": "LinkedField",
                            "name": "sites",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "siteId"
                              },
                              (v16/*: any*/)
                            ]
                          }
                        ],
                        "type": "AppSwitcherSiteScopedProduct"
                      }
                    ]
                  }
                ],
                "type": "AppSwitcherAvailableProductsBySite"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "message"
                  }
                ],
                "type": "QueryError"
              }
            ]
          }
        ]
      },
      {
        "alias": "navPlatL1MenuData",
        "args": (v8/*: any*/),
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_navigationCustomisation",
        "plural": false,
        "selections": (v18/*: any*/)
      },
      {
        "alias": "navPlatSidebarData",
        "args": (v10/*: any*/),
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_navigationCustomisation",
        "plural": false,
        "selections": (v18/*: any*/)
      }
    ]
  },
  "params": {
    "id": "1474f2f8bebba9d5221546b3bc69c4a186d0b8ab0687a3ae78f336d6f34f275e",
    "metadata": {},
    "name": "GlobalSideNavigationAGGRelayConnectionQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__getpagesizevaluerelayproviderts": pageSizeValue_provider
    }
  }
};
})();

(node as any).hash = "ab35b8bacb854ee35afb13ba3af258ac";

export default node;
